import React, { useState } from "react";
import Modal from "./parts/Modal";
// import ShopMain from "../assets/projects/shop-main.png";
// import ShopSearch from "../assets/projects/shop-search.png";
// import ShopProduct from "../assets/projects/shop-product.png";
// import ShopBankAcc from "../assets/projects/shop-bank-account.png";
// import ShopNoti from "../assets/projects/shop-notification.png";
// import ShopOrderConfirm from "../assets/projects/shop-orderconf.png";
// import ShopOrderInfo from "../assets/projects/shop-order-info.png";
import MMWedding from "../assets/projects/mm-main.png";
// import LS from "../assets/projects/ls-main.png";
import ZnakIPatentHome from "../assets/projects/znakipatent-home.png";
import IpLex from "../assets/projects/iplex-main.png"
import SOT from "../assets/projects/SOT-main.png"
import P from "../assets/projects/p.png"
import CAmain from "../assets/projects/CA-main.png"

const projects = [
  {
    title: "Creative Agency Website",
    description:
      "A modern, responsive website for a creative agency, featuring smooth animations and a portfolio showcase.",
    tech: ["Next.js", "Tailwind CSS", "TypeScript"],
    link: "https://creativity-lab.netlify.app/",
    image: CAmain,
  },
  {
    title: "Portfolio Website",
    description:
      "My personal portfolio website showcasing my projects and skills.",
    tech: ["Next.js", "Tailwind CSS", "TypeScript"],
    link: "https://marcindubinski.netlify.app/",
    image: P,
  },
   {
    title: "Study On Track - Learning/School Management App - Currently in Development",
    description: "A web application designed to facilitate learning and school management.",
    tech: ["Next.js", "Tailwind CSS", "TypeScript"],
    link: "https://studyontrack.netlify.app/",
    image: SOT,
  },
  {
    title: "Intelectual Property Law Company Website",
    description: "One Page application for IP law company. A bit different, more modern look, with smooth scrolling and nice animations.",
    tech: ["Next.js", "Tailwind CSS", "TypeScript"],
    link: "https://lexip.netlify.app/",
    image: IpLex,
  },
    {
    title: "My Wedding Page",
    description:
      "Quickly built wedding page with all the necessary information for guests.",
    tech: ["React", "Tailwind CSS"],
    link: "https://mm-wedding.netlify.app/",
    image: MMWedding,
  },
    {
    title: "Intelectual Property Law Company Website",
    description: "A simple informational website used by an IP law company, containing basic information, as much as is actually needed.",
    tech: ["Next.js", "Tailwind CSS", "TypeScript"],
    link: "https://znak-patent.netlify.app/",
    image: ZnakIPatentHome,
  },
//   {
//     title: "E-commerce Platform",
//     description:
//       "A scalable online store with integrated payments, admin dashboard, and analytics. Created for internal company use.",
//     tech: ["React", "Java", "Spring Boot", "PostgreSQL"],
//     link: "", // No URL, will open modal
//     image: ShopMain,
//     modal: {
//       images: [
//         ShopSearch,
//         ShopProduct,
//         ShopBankAcc,
//         ShopNoti,
//         ShopOrderConfirm,
//         ShopOrderInfo
//       ],
//       description:
//         "This internal e-commerce platform streamlines company sales and inventory. Features include user management, order tracking, and analytics dashboard.",
//     },
//   },
// {
//     title: "Learning School App",
//     description: "MVP of web app for learning school management. Created for improve learning process.",
//     tech: ["Html", "Css", "JavaScript"],
//     link: "",
//     image: LS,
//     modal: {
//       iframeUrl: "/Learning-school/home.html",
//     },
//   },

];

type Project = (typeof projects)[number];

const Projects = () => {
  const [modalProject, setModalProject] = useState<Project | null>(null);

  return (
    <section className="w-full bg-white py-20" id="projects">
      <Modal
        open={!!modalProject}
        onClose={() => setModalProject(null)}
        project={modalProject}
      />
      <div className="max-w-[1240px] mx-auto px-4">
        <h2
          className="text-4xl font-extrabold text-gray-900 mb-4"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          Past Projects
        </h2>
        <p className="text-lg text-gray-600 mb-12 max-w-2xl">
          A selection of products and apps I’ve built for clients and myself.
        </p>
        <div className="grid md:grid-cols-3 gap-8">
          {projects.map((project, idx) => (
            <div
              key={idx}
              className="bg-gray-50 rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-300 flex flex-col"
            >
              <div className="h-48 w-full overflow-hidden rounded-t-xl">
                <img
                  src={project.image}
                  alt={project.title}
                  className="object-cover w-full h-full transition-transform duration-300 hover:scale-105"
                />
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  {project.title}
                </h3>
                <p className="text-gray-700 mb-4 flex-1">
                  {project.description}
                </p>
                <div className="flex flex-wrap gap-2 mb-4">
                  {project.tech.map((tech, i) => (
                    <span
                      key={i}
                      className="bg-[#00df9a]/10 text-[#00df9a] px-3 py-1 rounded-full text-xs font-semibold"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
                {project.link ? (
                  <a
                    href={project.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block mt-auto text-[#00df9a] font-semibold hover:underline"
                  >
                    View Project →
                  </a>
                ) : (
                  <button
                    className="inline-block mt-auto text-[#00df9a] font-semibold hover:underline text-left"
                    onClick={() => setModalProject(project)}
                  >
                    View Details →
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
